import {useState} from 'react';

export const useSound = () => {
  const playCallSound = async () => {
    const callSound = new Audio('/aquila.ogg');
    let count = 0;
    callSound.addEventListener('ended', () => {
      if (count < 4) {
        callSound.play();
      }
      count++;
    });
    callSound.play();
  };

  const playMessageSound = () => {
    const messageSound = new Audio('/Iridium.ogg');
    messageSound.play();
  };

  return {
    playCallSound,
    playMessageSound,
  };
};
